import Vue from "vue"
import Vuex from 'vuex'
import {BLOCK_TYPE} from "@/pages/Campaign/utils/enum";

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    photos: [],
    navGroup: {},
    anchor: [],
    selectNavPhotoPoi: -1
  },
  mutations: {
    SET_BLOCKS(state, blocks) {
      state.photos = blocks.filter(e => e.type === BLOCK_TYPE.PHOTO)
      state.navGroup = blocks.find(e => e.type === BLOCK_TYPE.NAV)?.group

      // 默认选中各级导航的第一个
      const initAnchor = []
      let items = state.navGroup?.items || []

      while (items.length > 0) {
        initAnchor.push({
          id: items[0].id,
          level: items[0].level
        })

        items = items[0]?.group?.items || []
      }

      state.anchor = initAnchor
    },
    SET_ANCHOR(state, anchor) {
      state.anchor = anchor
    },
    SET_SELECTED_NAV_PHOTO_POI(state, poi) {
      state.selectNavPhotoPoi = poi
    }
  },
  actions: {
    selectedNavItem({ commit, state }, item) {
      const photo = state.photos.find(e => {
        if (!e.navAnchor) return null
        const included = e.navAnchor.find(f => f.id === item.id)
        return included ? e : null
      })

      const anchor = photo?.navAnchor
      // 如果没有对应的图片，不触发选中
      if (!anchor) return

      const selectPhoto = (anchor) => {
        const lastNavItemInfo = anchor[anchor.length - 1]
        if (!lastNavItemInfo) return

        const photo = state.photos?.find(e => e.navAnchor.find(f => f.id === lastNavItemInfo.id))
        if (photo) {
          commit('SET_SELECTED_NAV_PHOTO_POI', photo.poi)
        }
      }

      const newAnchor = []

      // 上层所有标签选中
      anchor.forEach(e => {
        if (e.level <= item.level) {
          newAnchor.push(e)
        }
      })

      let loopSub = item?.group?.items

      // 如果没有子标签，则所有层级已经选中
      if (!loopSub) {
        commit('SET_ANCHOR', newAnchor)
        selectPhoto(newAnchor)
        return
      }

      // 选中后续子标签的第一个
      while (loopSub && loopSub.length > 0) {
        const first = loopSub[0]
        if (!first) break

        newAnchor.push({
          id: first.id,
          level: first.level,
        })

        loopSub = first.group?.items
      }

      selectPhoto(newAnchor)

      commit('SET_ANCHOR', newAnchor)
    },
    onPhotoScrolled({ commit, state }, poi) {
      const photo = state.photos.find(e => e.poi === poi)

      const photoAnchor = photo?.navAnchor
      if (!photoAnchor) return

      if (state.anchor.length !== photoAnchor.length) return

      let sameAnchor = true

      for (let i = 0; i < state.anchor.length; i++) {
        sameAnchor = state.anchor[i].id === photoAnchor[i].id
        if (!sameAnchor) break
      }

      if (!sameAnchor) {
        commit('SET_ANCHOR', photoAnchor)
      }
    }
  }
})

export default store
